import { Download, FileSpreadsheet, FileText } from "lucide-react";
import { Button } from "../ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { toast } from "sonner";

interface ExportButtonProps {
  /** Label used in toast messages, e.g. "Energy Summary" */
  reportName: string;
  /** Optional custom class */
  className?: string;
}

const ExportButton = ({ reportName, className }: ExportButtonProps) => {
  const handleExport = (format: "csv" | "pdf") => {
    // Placeholder: in production, call your backend export API here
    toast.success(`${reportName} exported as ${format.toUpperCase()}`, {
      description: "Your download will begin shortly.",
    });
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          className={`h-8 gap-1.5 text-muted-foreground hover:text-foreground ${className ?? ""}`}
        >
          <Download className="w-3.5 h-3.5" />
          Export
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-40">
        <DropdownMenuItem
          onClick={() => handleExport("csv")}
          className="gap-2 cursor-pointer"
        >
          <FileSpreadsheet className="w-4 h-4 text-muted-foreground" />
          Export CSV
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => handleExport("pdf")}
          className="gap-2 cursor-pointer"
        >
          <FileText className="w-4 h-4 text-muted-foreground" />
          Export PDF
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default ExportButton;
